// src/components/Markdown.jsx
import React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize from 'rehype-sanitize';
import remarkGfm from 'remark-gfm';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { tomorrow } from 'react-syntax-highlighter/dist/esm/styles/prism';

const Markdown = ({ content }) => {
  return (
    <ReactMarkdown
      className="markdown-content"
      rehypePlugins={[rehypeRaw, rehypeSanitize]}
      remarkPlugins={[remarkGfm]}
      components={{
        // Custom rendering for code blocks with syntax highlighting
        code({ node, inline, className, children, ...props }) {
          const match = /language-(\w+)/.exec(className || '');
          return !inline && match ? (
            <SyntaxHighlighter
              style={tomorrow}
              language={match[1]}
              PreTag="div"
              {...props}
            >
              {String(children).replace(/\n$/, '')}
            </SyntaxHighlighter>
          ) : (
            <code className={className} {...props}>
              {children}
            </code>
          );
        },
        // Custom rendering for images to handle responsive images
        img({ node, ...props }) {
          return (
            <div className="markdown-image-container">
              <img {...props} className="markdown-image" />
            </div>
          );
        },
        // Custom rendering for links
        a({ node, ...props }) {
          return (
            <a 
              {...props}
              target={props.href.startsWith('http') ? '_blank' : undefined}
              rel={props.href.startsWith('http') ? 'noopener noreferrer' : undefined}
              className="markdown-link"
            />
          );
        },
        // Custom rendering for videos (requires special handling in your markdown)
        div({ node, className, children, ...props }) {
          if (className === 'video-container') {
            return (
              <div className="video-container" {...props}>
                {children}
              </div>
            );
          }
          return (
            <div className={className} {...props}>
              {children}
            </div>
          );
        }
      }}
    >
      {content}
    </ReactMarkdown>
  );
};

export default Markdown;